import {
  DELETE_ROLE_ACTION_TYPE,
  INSERT_UPDATE_ROLES_ACTION_TYPE,
  ROLES_LIST_ACTION_TYPE,
  ROLE_DETAILS_ACTION_TYPE,
} from "../../utils/constants";

const initialState = [];
function rolesReducer(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case ROLES_LIST_ACTION_TYPE:
      return [...state, payload];
    case ROLE_DETAILS_ACTION_TYPE:
      return [...state,payload];
    case INSERT_UPDATE_ROLES_ACTION_TYPE:
      return [...state, payload];
    case DELETE_ROLE_ACTION_TYPE:
      return [...state, payload];
    default:
      return state;
  }
}
export default rolesReducer;
